import type { WalletStake } from '../../api/walletStakes'

function formatDate(value: string) {
  const dt = new Date(value)
  if (Number.isNaN(dt.getTime())) return 'Invalid date'
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(dt)
}

function relativeTime(value: string) {
  const dt = new Date(value)
  if (Number.isNaN(dt.getTime())) return ''
  const diff = dt.getTime() - Date.now()
  const days = Math.ceil(Math.abs(diff) / (1000 * 60 * 60 * 24))
  if (diff >= 0) return `in ${days} day${days === 1 ? '' : 's'}`
  return `${days} day${days === 1 ? '' : 's'} ago`
}

function purposeLabel(p: string) {
  if (p === 'pro') return 'Pro Access'
  if (p === 'reporter_claim') return 'Reporter Claim'
  if (p === 'general') return 'General'
  if (p.startsWith('custom:')) return p.replace(/^custom:/, '')
  return p
}

export default function StakingStakeCard({
  stake,
  onUnstake,
  busy,
}: {
  stake: WalletStake
  onUnstake: (stake: WalletStake) => void
  busy?: boolean
}) {
  const unlockable = stake.status === 'active' && stake.is_unlockable
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-white font-semibold text-lg">{Number(stake.amount_pixe).toLocaleString()} PIXE</div>
          <div className="mt-1 flex items-center gap-2">
            <span className="inline-flex items-center rounded-full border border-white/20 bg-white/10 px-2 py-0.5 text-xs text-white/85">
              {purposeLabel(stake.purpose)}
            </span>
            <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${unlockable ? 'border-emerald-400/40 bg-emerald-500/15 text-emerald-100' : 'border-amber-400/40 bg-amber-500/15 text-amber-100'}`}>
              {unlockable ? 'Unlockable' : 'Locked'}
            </span>
          </div>
          <div className="mt-2 text-sm text-white/70">
            Locked until {formatDate(stake.locked_until)} ({relativeTime(stake.locked_until)})
          </div>
        </div>
        <button
          onClick={() => onUnstake(stake)}
          disabled={!unlockable || busy}
          className={`px-3 py-1.5 rounded-lg text-sm font-semibold border ${unlockable && !busy ? 'border-white/20 text-white/90 hover:bg-white/10' : 'border-white/10 text-white/50 cursor-not-allowed'}`}
        >
          {busy ? 'Unstaking...' : 'Unstake'}
        </button>
      </div>
    </div>
  )
}
